<template>
    <transition name="modal">
        <div class="modal" tabindex="-1" role="dialog" v-if="template">
            <div class="modal-dialog "
                 :class="[modalClass]"
                 role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <slot name="title">
                                Modal title
                            </slot>
                        </h5>

                        <button @click="hide" type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot v-if="!isComponent"></slot>

                        <component :is="component"
                                   :data="data"
                                   v-if="isComponent"
                                   @handler="eventHandler">

                        </component>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button @click="hide" type="button" class="btn btn-secondary">Close</button>
                            <button type="button" class="btn btn-primary">Save changes</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" v-else>
            <slot v-if="!isComponent"></slot>

            <component :is="component"
                       :data="data"
                       v-if="isComponent"
                       @handler="eventHandler">

            </component>
        </div>
    </transition>
</template>

<script>
    export default {
        props:   {
            onShow:   {
                type:    Function,
                default: () => {
                }
            },
            onHide:   {
                type:    Function,
                default: () => {
                }
            },
            template: {
                type:    Boolean,
                default: true
            }
        },
        mounted: function () {
            const self = this;
        },
        data() {
            return {
                component:   '',
                isComponent: false,
                data:        null,
                modalClass:  null,
            }
        },
        methods: {
            setComponent(component, data = null, modalClass = null) {
                const self = this;

                self.component   = component;
                self.isComponent = true;

                if (data !== null) {
                    self.data = data;
                }

                if (modalClass !== null) {
                    self.modalClass = modalClass;
                }
            },
            show() {
                const self = this;

                jQuery(self.$el)
                    .modal('show');

                this.onShow();
            },

            hide() {
                const self = this;

                jQuery(self.$el)
                    .modal('hide');

                this.onHide();
            },
            eventHandler(data) {
                const self = this;

                self.$emit('handler', data);
            }
        },
        unmounted() {
            jQuery(this.$el)
                .modal('dispose');
        }
    }
</script>